import {
  $elemMatch as __elemMatch,
  createQueryOperator
} from "../../_predicates";
const $elemMatch = createQueryOperator(__elemMatch);
export {
  $elemMatch
};
